import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CloudPaymentsCashierResponse as SchemaCloudPaymentsCashierResponse } from '../schemas/CloudPaymentsCashierResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetCloudPaymentsCashierContentType = '' as const;
export type GetCloudPaymentsCashierRequest = void;
export type GetCloudPaymentsCashierResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCloudPaymentsCashierResponse;
    };
};
export type GetCloudPaymentsCashierResponseSuccess = GetCloudPaymentsCashierResponses['200']['application/json'];
export type GetCloudPaymentsCashierSearchParams = undefined;
export type GetCloudPaymentsCashierPathParameters = undefined;
export const GetCloudPaymentsCashierUrl = '/cloudpayments/cashier' as const;
export const GetCloudPaymentsCashierMethod = 'GET' as const;
export const getGetCloudPaymentsCashierUrl = (_params?: GetCloudPaymentsCashierPathParameters) =>
    GetCloudPaymentsCashierUrl;
